import Vue from 'vue'
import VueRouter from 'vue-router'
import { checkAppVersion } from '@/services/versionCheck'
import auth from './auth'
import home from './home'
import financeiro from './financeiro'
import pedidos from './pedidos'
import tabela from './tabela'
import usuarios from './usuarios'
import errors from './errors'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...auth, 
    ...home,
    ...pedidos,
    ...financeiro,
    ...tabela,
    ...usuarios,
    ...errors,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
  // Check for app version updates on route transitions
  checkAppVersion()
})

// Handle chunk load errors when dynamic imports fail after a deployment
router.onError(error => {
  const isChunkError =
    error.name === 'ChunkLoadError' ||
    /loading chunk \d+ failed/i.test(error.message) ||
    /Loading CSS chunk \d+ failed/i.test(error.message) ||
    /Failed to fetch dynamically imported module/i.test(error.message)

  if (isChunkError) {
    window.location.reload(true)
  }
})

export default router
